import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import * as fromRoot from '@macs-frontend/reducers';
import { Store } from '@ngrx/store';

export enum LoaderContext {
  Table = 'table',
  Block = 'block',
  Absolute = 'absolute',
  Global = 'global',
}

type contextUnion = 'table' | 'block' | 'absolute' | 'global';

@Component({
  selector: 'md-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent extends BaseComponent implements OnInit {
  LoaderContext = LoaderContext;

  classPrefix = 'md-loader-';

  @Input() colspan?: number;
  @Input() context: contextUnion = LoaderContext.Table;
  @Input() actionTypes: null | string[] = null;

  // // eslint-disable-next-line @angular-eslint/no-input-rename
  // @HostBinding('class') @Input('class') classList = '';

  @SelectSubscribe(fromRoot.loaderInProgressSelector)
  loaderInProgress: string[] = [];

  ngOnInit(): void {
    // this.classList = this.classPrefix + this.context + ' ' + this.classList;
  }

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store<any>) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  showLoader() {
    return (
      !this.actionTypes ||
      this.actionTypes.some(type => this.loaderInProgress.includes(type))
    );
  }
}
